export const archiveOutcomes = { published: "Опубликовано", moderation: "Ушло на модерацию", active: "В работе", undelivered: "Не дошло до модерации", unconfirmed: "Результат не подтверждён" };
export function archiveFilters(hash = globalThis.location?.hash || "") {
  const q = new URLSearchParams(hash.split("?")[1] || "");
  return { site: q.get("site") === "app" ? "app" : "ru", source: ["all", "proxy", "harness"].includes(q.get("source")) ? q.get("source") : "all", period: ["24h", "7d", "30d", "90d", "all", "custom"].includes(q.get("period")) ? q.get("period") : "30d", query: q.get("query") || "", outcome: q.get("outcome") || "", timezone: ["Europe/Moscow","UTC","Europe/Berlin"].includes(q.get("timezone")) ? q.get("timezone") : "Europe/Moscow", fromDay: q.get("fromDay") || "", toDay: q.get("toDay") || "", from: q.get("from") || "", to: q.get("to") || "", execution: q.get("execution") || "", snapshotId: q.get("snapshotId") || "" };
}
export function archiveQuery(f, snapshotId = f.snapshotId) {
  const q = new URLSearchParams({ site: f.site, source: f.source, period: f.period, timezone: f.timezone });
  for (const key of ["query", "outcome", "from", "to", "fromDay", "toDay"]) if (f[key]) q.set(key, f[key]);
  if (snapshotId) q.set("snapshotId", snapshotId);
  return q;
}
export function archiveMoney(amount) { return amount == null ? "Стоимость неизвестна" : `${amount} USD`; }
export function archiveTooltip(point, timezone = "Europe/Moscow") {
  const e = point.execution;
  const partial = Number(point.unknownCosts || 0) > 0;
  const money = point.knownUsd == null ? archivePointMoney(point) : `${partial ? "Не менее " : ""}${archiveMoney(point.knownUsd)}${partial ? "; учтено частично" : ""}`;
  const date = new Intl.DateTimeFormat("ru", { dateStyle: "medium", timeStyle: "short", timeZone: timezone }).format(new Date(e.createdAt));
  return `Запуск ${e.jobNumber || "без сохранённого номера"} · ${e.title} · ${archiveNamespace(e.namespace)} · ${date}. ${archiveOutcomes[point.outcome] || archiveOutcomes.unconfirmed}. ${money}. Вызовов: ${point.physicalCalls ?? "нет данных"}. Опубликовано ${e.published ?? "нет данных"}; передано ${e.delivered ?? "нет данных"}; заказано ${e.requested ?? "нет данных"}. Исполнитель: ${archiveOwner(e.executionOwner)}; состояние: ${archiveStatus(e.rawStatus)}.${e.domainObservedAt ? ` Результат актуален на ${archiveDate(e.domainObservedAt, timezone)}.` : ""}`;
}
// Only individual server points are plotted. Unknown/non-USD costs break each
// namespace's path and never become zero. Ordinal X preserves original labels.
export function archiveChart(points, availableWidth = 1000, height = 320) {
  const groups = new Map();
  points.forEach((p) => { const ns = p.execution.namespace; if (!groups.has(ns)) groups.set(ns, []); groups.get(ns).push(p); });
  const numeric = points.flatMap((p) => p.knownUsd == null ? [] : [Number(p.knownUsd)]).filter(Number.isFinite);
  const max = Math.max(0.01, ...numeric);
  return [...groups].map(([namespace, items]) => {
    const sorted = [...items].sort((a, b) => (a.execution.jobNumber || 0) - (b.execution.jobNumber || 0));
    const width = Math.max(720, availableWidth, sorted.length * 54 + 96);
    const plot = { left: 68, right: width - 28, top: 28, bottom: height - 54 };
    const marks = sorted.map((p, i) => ({ ...p,
      x: plot.left + (sorted.length === 1 ? (plot.right - plot.left) / 2 : i * (plot.right - plot.left) / (sorted.length - 1)),
      y: p.knownUsd == null || !Number.isFinite(Number(p.knownUsd)) ? null : plot.bottom - Number(p.knownUsd) / max * (plot.bottom - plot.top),
    }));
    let path = ""; let previousKnown = false;
    for (const p of marks) { if (p.y == null) { previousKnown = false; continue; } path += `${previousKnown ? "L" : "M"}${p.x},${p.y} `; previousKnown = true; }
    const ticks = Array.from({ length: 5 }, (_, i) => ({ value: max * i / 4, y: plot.bottom - i / 4 * (plot.bottom - plot.top) }));
    const spacing = (plot.right - plot.left) / Math.max(1, marks.length - 1);
    return { namespace, marks, path, max, width, height, plot, ticks, labelStep: Math.max(1, Math.ceil(90 / spacing)) };
  });
}

export function archiveNamespace(namespace) {
  return ({ ru: "triproutes.ru", "routes-ru": "triproutes.ru", app: "triproutes.app", "routes-app": "triproutes.app" })[namespace] || namespace;
}
export function archiveOwner(owner) {
  return ({ harness: "Harness", proxy: "Старый Proxy", legacy: "Старый Proxy", mixed: "Смешанное исполнение" })[owner] || owner || "Не подтверждён";
}
export function archiveSource(execution) {
  return [execution.legacyMember && "История Proxy", execution.harnessMember && "Harness"].filter(Boolean).join(" + ") || "Источник не подтверждён";
}
export function archiveStatus(status) {
  return ({
    queued: "В очереди", ideas_running: "Агент 1 работает", retry: "Ожидает повтор",
    candidates_ready: "Кандидаты готовы", assembly_running: "Агент 3 работает",
    assembly_retry: "Повтор Агента 3", drafts_ready: "Маршруты собраны",
    fact_check_running: "Агент 4 работает", fact_check_ready: "Проверка завершена",
    fact_check_review: "Нужна проверка", import_running: "Передача в TripRoutes",
    import_review: "Нужна доработка", completed: "Завершён", partial_delivery: "Частично",
    repair_required: "Нужна доработка", no_routes: "Нет маршрутов", failed: "Ошибка",
    budget_exceeded: "Бюджет исчерпан", canceled: "Отменён", cancelled: "Отменён", unknown: "Неизвестно",
  })[status] || status || "Неизвестно";
}
export function archiveCount(value) {
  return value == null ? "—" : new Intl.NumberFormat("ru-RU").format(value);
}
function archiveQuantity(value, units) {
  const mod100 = value % 100, mod10 = value % 10;
  const unit = mod100 >= 11 && mod100 <= 14 ? units[2] : mod10 === 1 ? units[0] : mod10 >= 2 && mod10 <= 4 ? units[1] : units[2];
  return `${archiveCount(value)} ${unit}`;
}
export function archiveRunsLabel(value) { return archiveQuantity(value, ["запуск", "запуска", "запусков"]); }
export function archiveCallsLabel(value) { return archiveQuantity(value, ["вызов", "вызова", "вызовов"]); }
export function archivePercent(value, total) {
  return value == null || total == null || total <= 0 ? "—" : `${new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 1 }).format(value * 100 / total)}%`;
}
export function archiveAgentCells(execution) {
  const c = execution.counters || {};
  return {
    agent0: archiveQuantity(c.agent0_objects, ["объект", "объекта", "объектов"]),
    agent1: `${archiveQuantity(c.ideas, ["идея", "идеи", "идей"])} · ${archiveQuantity(c.proposed_objects, ["объект", "объекта", "объектов"])}`,
    agent2: `${archiveCount(c.photos)} фото · ${archivePercent(c.photo_covered_objects, c.proposed_objects)} (${archiveCount(c.photo_covered_objects)}/${archiveCount(c.proposed_objects)} объектов)`,
    agent3: `${archiveCount(execution.formed)}/${archiveCount(execution.requested)} · ${archivePercent(execution.formed, execution.requested)}`,
    // Partial checks are a subset of completed checks, never an extra total.
    agent4: `${archiveCount(c.fact_check_completed)} выполнено, из них ${archiveCount(c.fact_check_partial)} частично`,
    agent4Delivery: `${archiveCount(c.fact_check_failed)} ошибок · ${archiveCount(execution.delivered)} передано`,
  };
}
export function archiveDate(instant, timezone, compact = false) {
  if (!instant || !Number.isFinite(Date.parse(instant))) return "—";
  return new Intl.DateTimeFormat("ru-RU", compact
    ? { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: timezone }
    : { dateStyle: "medium", timeStyle: "short", timeZone: timezone }).format(new Date(instant));
}
export function archiveAxisMoney(value) {
  if (value > 0 && value < 0.000001) return `$${value.toExponential(1)}`;
  return `$${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: value > 0 && value < 0.01 ? 8 : 2 }).format(value)}`;
}

// Calendar boundaries use the selected timezone, not the machine's timezone.
export function archiveDayUTC(day, timezone, inclusiveEnd = false) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) throw new Error("Введите дату");
  let target = Date.parse(`${day}T00:00:00Z`);
  if (!Number.isFinite(target) || new Date(target).toISOString().slice(0,10)!==day) throw new Error("Некорректная дата");
  if (inclusiveEnd) target += 86400000;
  let instant = target;
  const formatter = new Intl.DateTimeFormat("en-GB", { timeZone: timezone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" });
  for (let i = 0; i < 4; i++) { const parts = Object.fromEntries(formatter.formatToParts(new Date(instant)).map((p) => [p.type, p.value])); const wall = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second); const delta = target - wall; instant += delta; if (!delta) return new Date(instant).toISOString(); }
  throw new Error("Не удалось определить границу даты в часовом поясе");
}

export function archiveCostGroup(key) {
 const labels={total:"Известные расходы",city_points:"Расходы точек графика",independent_manual:"Самостоятельные доработки",manual_outside_cities:"Доработки запусков вне выборки",unallocated:"Нераспределённые расходы"};
 if(labels[key]) return labels[key];if(key.startsWith("agent:")) return `Агент ${key.slice(6)==="other"?"не определён":key.slice(6)}`;if(key.startsWith("provider:")) return `Провайдер ${key.slice(9)==="other"?"не определён":key.slice(9)}`;return "Прочие расходы";
}

export function archivePointMoney(point) {
 const values=Object.entries(point.knownAmounts||{}).filter(([currency,amount])=>amount!=null&&currency!=="unknown").map(([currency,amount])=>`${amount} ${currency}`);
 return values.length?values.join("; "):archiveMoney(point.knownUsd);
}
export function archiveCalendarFilters(f,patch) {
 const next={...f,...patch};
 if(next.period==="custom") {
  if(next.fromDay)next.from=archiveDayUTC(next.fromDay,next.timezone);
  if(next.toDay)next.to=archiveDayUTC(next.toDay,next.timezone,true);
 }
 return next;
}
